/**
 * The call's end reminder, for both sides (decision 80). The time is in the
 * viewer's zone; "America/New_York" when the zone is not known.
 */
export interface RoomEndChip {
  title: string;
  detail: string;
}

const REMINDER_MS = 5 * 60_000;

function endTime(endMs: number, timeZone: string): string {
  const opts: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
  let parts: Intl.DateTimeFormatPart[];
  try {
    parts = new Intl.DateTimeFormat('en-US', { ...opts, timeZone }).formatToParts(endMs);
  } catch {
    parts = new Intl.DateTimeFormat('en-US', { ...opts, timeZone: 'America/New_York' })
      .formatToParts(endMs);
  }
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  // Every time carries AM or PM (decision 6; finding 26).
  return `${get('hour')}:${get('minute')} ${get('dayPeriod').toUpperCase()}`;
}

/**
 * The chip (decision 80): from 5 minutes before the scheduled end, "5
 * minutes left"; from the end until the call closes 15 minutes later (53),
 * "Your lesson ended at 3:45 PM. The call closes at 4:00 PM."; else null.
 */
export function roomEndChip(
  scheduledStartAt: string, durationMinutes: number, now: number, timeZone: string,
): RoomEndChip | null {
  const endMs = new Date(scheduledStartAt).getTime() + durationMinutes * 60_000;
  const closeMs = endMs + 15 * 60_000;
  if (now < endMs - REMINDER_MS || now >= closeMs) return null;
  if (now < endMs) return { title: '5 minutes left', detail: '' };
  return { title: `Your lesson ended at ${endTime(endMs, timeZone)}. The call closes at ${endTime(closeMs, timeZone)}.`, detail: '' };
}
